<template>
  <BillingEmail v-if="auth.hasCompanyScoped(Permission.Company_UpdateDetails)" class="my-4" />
  <ListInvoicesV1 v-if="!posthog?.isFeatureEnabled('invoices-v2')" />
  <ListInvoicesV2 v-else />
</template>

<script setup lang="ts">
import { PostHog } from "posthog-js";
import { inject } from "vue";
import { useAuthorizationStore, Permission } from "@/store/authorization";

const auth = useAuthorizationStore();
const posthog = inject<PostHog>("posthog");
</script>
